import { render, staticRenderFns } from "./ChangeTransactionAffiliateModal.vue?vue&type=template&id=2e888bdb"
import script from "./ChangeTransactionAffiliateModal.vue?vue&type=script&lang=js"
export * from "./ChangeTransactionAffiliateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports